(function () {
  const ICON_PIN =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 22s7-7.2 7-12a7 7 0 1 0-14 0c0 4.8 7 12 7 12Z" fill="currentColor"/><circle cx="12" cy="10" r="2.4" fill="#fff"/></svg>';
  const ICON_HOME =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 10.5 12 4l8 6.5V20H4v-9.5Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9 20v-6h6v6" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
  const ICON_GLOBE =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M4 12h16M12 4c2.5 2.4 3.8 5.2 3.8 8S14.5 17.6 12 20c-2.5-2.4-3.8-5.2-3.8-8S9.5 6.4 12 4Z" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
  const ICON_PHONE =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 3.8h3.2l1.2 3.2-2 1.6a12 12 0 0 0 6.5 6.5l1.6-2 3.2 1.2v3.2c0 .7-.6 1.3-1.3 1.3C10.4 18.8 5.2 13.6 5.2 5.1c0-.7.6-1.3 1.3-1.3Z" fill="currentColor"/></svg>';
  const ICON_MAIL =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 6h16v12H4V6Z" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="m4 7 8 6 8-6" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  const ICON_CHEVRON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function whenMapLibre(fn) {
    if (window.maplibregl) {
      fn();
      return;
    }
    let tries = 0;
    const timer = setInterval(function () {
      tries += 1;
      if (window.maplibregl) {
        clearInterval(timer);
        fn();
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function parseJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) {
      return tags.map(function (tag) { return String(tag).trim(); }).filter(Boolean);
    }
    if (typeof tags === 'string') {
      return tags.split(',').map(function (tag) { return tag.trim(); }).filter(Boolean);
    }
    return [];
  }

  function toNumber(value) {
    const number = parseFloat(value);
    return Number.isFinite(number) ? number : null;
  }

  function normalizePartner(raw) {
    if (!raw) return null;
    const lat = toNumber(raw.lat);
    const lng = toNumber(raw.lng);
    return {
      id: String(raw.id || ''),
      name: raw.name || '',
      tags: normalizeTags(raw.tags),
      city: raw.city || '',
      country: raw.country || '',
      address: raw.address || '',
      website: raw.website || '',
      phone: raw.phone || '',
      email: raw.email || '',
      lat: lat,
      lng: lng,
      hasCoords: lat != null && lng != null
    };
  }

  function locationLabel(partner) {
    return [partner.city, partner.country].filter(Boolean).join(', ');
  }

  function websiteHref(url) {
    if (!url) return '';
    if (/^https?:\/\//i.test(url)) return url;
    return 'https://' + url;
  }

  function countLabel(i18n, count) {
    const template = count === 1 ? i18n.countOne : i18n.countOther;
    return String(template).replace(/__COUNT__/g, String(count));
  }

  function loadedLabel(i18n, loaded, total) {
    return String(i18n.loaded)
      .replace(/__LOADED__/g, String(loaded))
      .replace(/__TOTAL__/g, String(total));
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function isPartnerMessageSuccess(response, payload) {
    if (payload && payload.code != null) return Number(payload.code) === 200;
    return Boolean(response && response.ok && (!payload || payload.ok !== false));
  }

  function partnerMessageError(payload, fallback) {
    if (!payload) return fallback;
    if (payload.code != null && Number(payload.code) !== 200 && payload.msg) return String(payload.msg);
    if (typeof payload.error === 'string' && payload.error) return payload.error;
    if (typeof payload.message === 'string' && payload.message) return payload.message;
    if (payload.errors) {
      return typeof payload.errors === 'string' ? payload.errors : JSON.stringify(payload.errors);
    }
    if (typeof payload.msg === 'string' && payload.msg) return payload.msg;
    return fallback;
  }

  const DEMO_PARTNERS = [
    {
      id: 'demo-munich',
      name: 'Sunster Europe GmbH',
      tags: ['Distributor', 'Seller', 'Service'],
      city: 'Munich',
      country: 'Germany',
      address: 'Leopoldstrasse 8',
      website: 'https://sunsterdirect.com',
      phone: '+49 89 1234 5678',
      email: 'demo@example.com',
      lat: 48.137154,
      lng: 11.576124
    },
    {
      id: 'demo-milan',
      name: 'AUTOCLIMA S.P.A. a socio unico',
      tags: ['Distributor', 'OEM', 'Seller'],
      city: 'Cambiano TO',
      country: 'Italy',
      address: 'Via Cavalieri di Vittorio Veneto 15',
      website: 'https://www.autoclima.com',
      phone: '+39 011 944 3210',
      email: 'demo@example.com',
      lat: 44.9712,
      lng: 7.7794
    },
    {
      id: 'demo-amsterdam',
      name: 'A/S SERVITEK',
      tags: ['Seller', 'Service', 'Certified'],
      city: 'Amsterdam',
      country: 'Netherlands',
      address: 'Keizersgracht 126',
      website: 'https://sunsterdirect.com',
      phone: '+31 20 123 4567',
      email: 'demo@example.com',
      lat: 52.3676,
      lng: 4.9041
    }
  ];

  class PartnerLocator {
    constructor(root) {
      this.root = root;
      this.config = parseJson(root.querySelector('[data-partner-locator-config]')) || {};
      this.i18n = this.config.i18n || {};
      this.partners = [];
      this.byId = {};
      this.selectedId = null;
      this.visibleIds = '';
      this.map = null;
      this.popup = null;
      this.flySeq = 0;
      this.initialBounds = null;
      this.submitting = false;
      this.activePartner = null;
      this.filterQuery = '';
      this.filterCountry = '';
      this.filterService = '';
      this.filterTimer = null;
      this.filtersEl = document.querySelector('[data-partner-filters]');
      this.listEl = root.querySelector('[data-partner-list]');
      this.countEl = root.querySelector('[data-partner-count]');
      this.loadedEl = root.querySelector('[data-partner-loaded]');
      this.mapEl = root.querySelector('[data-partner-map]');
      this.mapWrap = root.querySelector('.partner-locator__map-wrap');
      this.modal = root.querySelector('[data-partner-modal]');
      this.form = root.querySelector('[data-partner-form]');
      this.formError = root.querySelector('[data-partner-form-error]');
      this.submitBtn = root.querySelector('[data-partner-submit]');
      this.submitLabel = root.querySelector('[data-partner-submit-label]');
      this.modalName = root.querySelector('[data-partner-modal-name]');
      this.bindUi();
      this.boot();
    }

    bindUi() {
      const self = this;
      this.root.querySelector('[data-partner-fullscreen]').addEventListener('click', function () {
        self.toggleFullscreen();
      });
      this.root.querySelector('[data-partner-locate]').addEventListener('click', function () {
        self.locateMe();
      });
      this.root.querySelector('[data-partner-reset]').addEventListener('click', function () {
        self.resetView();
      });
      this.root.querySelectorAll('[data-partner-modal-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.closeModal();
        });
      });
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        self.submitForm();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') self.closeModal();
      });
      document.addEventListener('fullscreenchange', function () {
        if (self.map) self.map.resize();
      });
      this.bindFilters();
    }

    bindFilters() {
      const self = this;
      if (!this.filtersEl) return;
      const queryInput = this.filtersEl.querySelector('[data-partner-filter-query]');
      const countrySelect = this.filtersEl.querySelector('[data-partner-filter-country]');
      const serviceSelect = this.filtersEl.querySelector('[data-partner-filter-service]');
      if (queryInput) {
        queryInput.addEventListener('input', function () {
          self.filterQuery = String(queryInput.value || '');
          clearTimeout(self.filterTimer);
          self.filterTimer = setTimeout(function () {
            self.applyFilters({ fly: true });
          }, 220);
        });
        queryInput.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          clearTimeout(self.filterTimer);
          self.filterQuery = String(queryInput.value || '');
          self.applyFilters({ fly: true });
        });
      }
      if (countrySelect) {
        countrySelect.addEventListener('change', function () {
          self.filterCountry = String(countrySelect.value || '');
          self.applyFilters({ fly: true });
        });
      }
      if (serviceSelect) {
        serviceSelect.addEventListener('change', function () {
          self.filterService = String(serviceSelect.value || '');
          self.applyFilters({ fly: true });
        });
      }
    }

    hasActiveFilters() {
      return Boolean(this.filterQuery.trim() || this.filterCountry || this.filterService);
    }

    partnerSearchText(partner) {
      return [
        partner.name,
        partner.city,
        partner.country,
        partner.address,
        partner.phone,
        partner.email,
        partner.website,
        (partner.tags || []).join(' ')
      ].join(' ').toLowerCase();
    }

    filteredPartners() {
      const self = this;
      const query = this.filterQuery.trim().toLowerCase();
      const country = this.filterCountry;
      const service = this.filterService;
      return this.partners.filter(function (partner) {
        if (country && partner.country !== country) return false;
        if (service && (partner.tags || []).indexOf(service) === -1) return false;
        if (query && self.partnerSearchText(partner).indexOf(query) === -1) return false;
        return true;
      });
    }

    uniqueSorted(values) {
      const seen = {};
      values.forEach(function (value) {
        const key = String(value || '').trim();
        if (key) seen[key] = true;
      });
      return Object.keys(seen).sort(function (a, b) {
        return a.localeCompare(b);
      });
    }

    fillSelect(select, values, selected) {
      if (!select) return;
      const first = select.querySelector('option[value=""]');
      const allLabel = first ? first.textContent : '';
      select.innerHTML = '';
      const allOption = document.createElement('option');
      allOption.value = '';
      allOption.textContent = allLabel;
      select.appendChild(allOption);
      values.forEach(function (value) {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      select.value = values.indexOf(selected) === -1 ? '' : selected;
    }

    populateFilterOptions() {
      if (!this.filtersEl) return;
      const countrySelect = this.filtersEl.querySelector('[data-partner-filter-country]');
      const serviceSelect = this.filtersEl.querySelector('[data-partner-filter-service]');
      const countries = this.uniqueSorted(this.partners.map(function (partner) { return partner.country; }));
      const services = this.uniqueSorted(this.partners.reduce(function (list, partner) {
        return list.concat(partner.tags || []);
      }, []));
      this.fillSelect(countrySelect, countries, this.filterCountry);
      this.fillSelect(serviceSelect, services, this.filterService);
      this.filterCountry = countrySelect ? countrySelect.value : '';
      this.filterService = serviceSelect ? serviceSelect.value : '';
    }

    refreshMapSource() {
      if (!this.map || !this.map.getSource('partners')) return;
      this.map.getSource('partners').setData(this.geojson());
    }

    focusMatches(matches) {
      const coords = (matches || []).filter(function (partner) { return partner.hasCoords; });
      if (!coords.length || !this.map) return;
      if (coords.length === 1) {
        this.flyToPartner(coords[0], true);
        return;
      }
      const bounds = new maplibregl.LngLatBounds();
      coords.forEach(function (partner) {
        bounds.extend([partner.lng, partner.lat]);
      });
      this.map.fitBounds(bounds, { padding: 64, maxZoom: 12, duration: 800 });
    }

    renderFilteredResults(options) {
      const matches = this.filteredPartners();
      const ids = matches.map(function (partner) { return partner.id; }).join('|');
      if (ids !== this.visibleIds) {
        this.visibleIds = ids;
        this.renderList(matches);
        this.refreshMapSource();
      }
      if (this.selectedId) {
        const card = this.listEl.querySelector('[data-partner-card="' + this.selectedId + '"]');
        if (card) card.scrollIntoView({ block: 'nearest' });
      }
      if (options && options.fly) this.focusMatches(matches);
    }

    applyFilters(options) {
      this.visibleIds = '';
      if (!this.hasActiveFilters()) {
        this.refreshMapSource();
        this.filterListToBounds();
        return;
      }
      this.renderFilteredResults(options || { fly: true });
    }

    async boot() {
      const first = parseJson(this.root.querySelector('[data-partner-locator-payload]')) || {
        partners: [],
        page: 1,
        pages: 1,
        total: 0
      };
      this.addPartners(first.partners || []);
      if (!this.partners.length && this.config.enableDemo === true) {
        this.addPartners(DEMO_PARTNERS);
        first.total = DEMO_PARTNERS.length;
        first.pages = 1;
      }
      this.setLoaded(this.partners.length, first.total || this.partners.length);
      if ((first.pages || 1) > 1) {
        await this.loadRemainingPages(first);
      }
      this.setLoaded(this.partners.length, this.partners.length);
      this.populateFilterOptions();
      this.renderList(this.filteredPartners());
      whenMapLibre(this.initMap.bind(this));
    }

    addPartners(list) {
      const self = this;
      (list || []).forEach(function (item) {
        const partner = normalizePartner(item);
        if (!partner || !partner.id || self.byId[partner.id]) return;
        self.byId[partner.id] = partner;
        self.partners.push(partner);
      });
    }

    async loadRemainingPages(first) {
      for (let page = 1; page <= first.pages; page += 1) {
        if (page === first.page) continue;
        try {
          const payload = await this.fetchPage(page);
          this.addPartners(payload && payload.partners);
          this.setLoaded(this.partners.length, first.total || this.partners.length);
        } catch (error) {
          break;
        }
      }
    }

    async fetchPage(page) {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.config.sectionId);
      url.searchParams.set('page', String(page));
      const response = await fetch(url.toString());
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return parseJson(doc.querySelector('[data-partner-locator-payload]'));
    }

    setLoaded(loaded, total) {
      if (this.loadedEl) this.loadedEl.textContent = loadedLabel(this.i18n, loaded, total);
    }

    setCount(count) {
      if (this.countEl) this.countEl.textContent = countLabel(this.i18n, count);
    }

    renderList(partners) {
      const self = this;
      this.setCount(partners.length);
      this.listEl.innerHTML = partners.map(function (partner) {
        return self.cardHtml(partner);
      }).join('');
      this.listEl.querySelectorAll('[data-partner-card]').forEach(function (card) {
        card.addEventListener('click', function (event) {
          if (event.target.closest('a, button')) return;
          self.selectPartner(card.getAttribute('data-partner-card'), { fly: true, popup: true });
        });
      });
      this.listEl.querySelectorAll('[data-partner-message]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.stopPropagation();
          self.openModal(button.getAttribute('data-partner-message'));
        });
      });
      if (this.selectedId) {
        const active = this.listEl.querySelector('[data-partner-card="' + this.selectedId + '"]');
        if (active) active.classList.add('is-active');
      }
    }

    cardHtml(partner) {
      const tags = partner.tags.map(function (tag) {
        return '<span class="partner-locator__tag">' + escapeHtml(tag) + '</span>';
      }).join('');
      const loc = locationLabel(partner);
      const website = websiteHref(partner.website);
      return (
        '<article class="partner-locator__card" data-partner-card="' + escapeHtml(partner.id) + '">' +
          (tags ? '<div class="partner-locator__tags">' + tags + '</div>' : '') +
          '<h3 class="partner-locator__name">' + escapeHtml(partner.name) + '</h3>' +
          (loc ? '<p class="partner-locator__meta partner-locator__meta--pin">' + ICON_PIN + '<span>' + escapeHtml(loc) + '</span></p>' : '') +
          (partner.address ? '<p class="partner-locator__meta">' + ICON_HOME + '<span>' + escapeHtml(partner.address) + '</span></p>' : '') +
          // (website ? '<p class="partner-locator__meta">' + ICON_GLOBE + '<a href="' + escapeHtml(website) + '" target="_blank" rel="noopener">' + escapeHtml(partner.website) + '</a></p>' : '') +
          '' +
          '<div class="partner-locator__actions">' +
            // (partner.phone
            //   ? '<a class="partner-locator__phone" href="tel:' + escapeHtml(partner.phone) + '">' + ICON_PHONE + '<span>' + escapeHtml(partner.phone) + '</span></a>'
            //   : '') +
            (partner.phone
            ? '<a class="partner-locator__phone" href="tel:' + escapeHtml(partner.phone) + '">' + ICON_PHONE + '</a>'
            : '') +
            '<button type="button" class="partner-locator__message" data-partner-message="' + escapeHtml(partner.id) + '">' +
              ICON_MAIL + '<span>' + escapeHtml(this.i18n.message) + '</span>' + ICON_CHEVRON +
            '</button>' +
          '</div>' +
        '</article>'
      );
    }

    initMap() {
      if (!this.mapEl || !window.maplibregl) return;
      const self = this;
      this.map = new maplibregl.Map({
        container: this.mapEl,
        style: this.config.styleUrl,
        center: [0, 20],
        zoom: 1.4,
        attributionControl: true,
        cooperativeGestures: window.matchMedia('(max-width: 749px)').matches
      });
      this.popup = new maplibregl.Popup({
        closeButton: true,
        closeOnClick: true,
        className: 'partner-locator-popup',
        maxWidth: '300px',
        anchor: 'bottom',
        offset: 14,
        focusAfterOpen: false
      });
      this.flySeq = 0;
      this.map.on('load', function () {
        self.addPartnerLayers();
        self.fitToPartners();
        self.filterListToBounds();
      });
      this.map.on('moveend', function () {
        self.filterListToBounds();
      });
      if (this.config.cluster) {
        this.map.on('click', 'clusters', function (event) {
          const features = self.map.queryRenderedFeatures(event.point, { layers: ['clusters'] });
          if (!features.length) return;
          const clusterId = features[0].properties.cluster_id;
          self.map.getSource('partners').getClusterExpansionZoom(clusterId, function (err, zoom) {
            if (err) return;
            self.map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          });
        });
        this.map.on('mouseenter', 'clusters', function () { self.map.getCanvas().style.cursor = 'pointer'; });
        this.map.on('mouseleave', 'clusters', function () { self.map.getCanvas().style.cursor = ''; });
      }
      this.map.on('click', 'unclustered', function (event) {
        const id = featuresId(event);
        if (id) self.selectPartner(id, { fly: false, popup: true, scrollList: true });
      });
      this.map.on('mouseenter', 'unclustered', function () { self.map.getCanvas().style.cursor = 'pointer'; });
      this.map.on('mouseleave', 'unclustered', function () { self.map.getCanvas().style.cursor = ''; });
    }

    geojson(list) {
      const partners = list || this.filteredPartners();
      return {
        type: 'FeatureCollection',
        features: partners.filter(function (partner) { return partner.hasCoords; }).map(function (partner) {
          return {
            type: 'Feature',
            id: partner.id,
            geometry: { type: 'Point', coordinates: [partner.lng, partner.lat] },
            properties: { id: partner.id }
          };
        })
      };
    }

    addPartnerLayers() {
      const color = this.config.primaryColor || '#0C8CE9';
      this.map.addSource('partners', {
        type: 'geojson',
        data: this.geojson(),
        cluster: Boolean(this.config.cluster),
        clusterMaxZoom: 14,
        clusterRadius: this.config.clusterRadius || 50,
        promoteId: 'id'
      });
      if (this.config.cluster) {
        this.map.addLayer({
          id: 'clusters',
          type: 'circle',
          source: 'partners',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': color,
            'circle-radius': ['step', ['get', 'point_count'], 16, 20, 22, 100, 28],
            'circle-opacity': 0.88
          }
        });
        this.map.addLayer({
          id: 'cluster-count',
          type: 'symbol',
          source: 'partners',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count_abbreviated}',
            'text-size': 12
          },
          paint: { 'text-color': '#ffffff' }
        });
      }
      this.map.addLayer({
        id: 'unclustered',
        type: 'circle',
        source: 'partners',
        filter: this.config.cluster ? ['!', ['has', 'point_count']] : ['all'],
        paint: {
          'circle-color': color,
          'circle-radius': ['case', ['boolean', ['feature-state', 'selected'], false], 10, 7],
          'circle-stroke-width': ['case', ['boolean', ['feature-state', 'selected'], false], 2.4, 1.8],
          'circle-stroke-color': '#ffffff'
        }
      });
    }

    fitToPartners() {
      const coords = this.partners.filter(function (partner) { return partner.hasCoords; });
      if (!coords.length || !this.map) return;
      if (coords.length === 1) {
        this.map.jumpTo({ center: [coords[0].lng, coords[0].lat], zoom: 10 });
        this.initialBounds = this.map.getBounds();
        return;
      }
      const bounds = new maplibregl.LngLatBounds();
      coords.forEach(function (partner) {
        bounds.extend([partner.lng, partner.lat]);
      });
      this.map.fitBounds(bounds, { padding: 48, maxZoom: 8, duration: 0 });
      this.initialBounds = bounds;
    }

    filterListToBounds() {
      if (this.hasActiveFilters()) return;
      if (!this.map) {
        this.renderList(this.partners);
        return;
      }
      const bounds = this.map.getBounds();
      const visible = this.partners.filter(function (partner) {
        return partner.hasCoords && bounds.contains([partner.lng, partner.lat]);
      });
      const ids = visible.map(function (partner) { return partner.id; }).join('|');
      if (ids === this.visibleIds) return;
      this.visibleIds = ids;
      this.renderList(visible);
      if (this.selectedId) {
        const card = this.listEl.querySelector('[data-partner-card="' + this.selectedId + '"]');
        if (card) card.scrollIntoView({ block: 'nearest' });
      }
    }

    selectPartner(id, options) {
      const partner = this.byId[id];
      if (!partner) return;
      const opts = options || {};
      if (this.selectedId && this.map) {
        try { this.map.setFeatureState({ source: 'partners', id: this.selectedId }, { selected: false }); } catch (e) {}
      }
      this.selectedId = id;
      if (this.map && partner.hasCoords) {
        try { this.map.setFeatureState({ source: 'partners', id: id }, { selected: true }); } catch (e) {}
      }
      this.root.querySelectorAll('[data-partner-card]').forEach(function (card) {
        card.classList.toggle('is-active', card.getAttribute('data-partner-card') === id);
      });
      if (opts.scrollList) {
        const card = this.listEl.querySelector('[data-partner-card="' + id + '"]');
        if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      if (opts.popup && partner.hasCoords && this.map && opts.fly) {
        this.flyToPartner(partner, true);
        return;
      }
      if (partner.hasCoords && this.map && opts.fly) {
        this.flyToPartner(partner, false);
      }
      if (opts.popup && partner.hasCoords) this.openPopup(partner);
    }

    flyToPartner(partner, showPopup) {
      const self = this;
      const seq = ++this.flySeq;
      if (this.popup) this.popup.remove();
      const targetZoom = 12;
      const center = this.map.getCenter();
      const alreadyClose =
        this.map.getZoom() >= targetZoom - 0.2 &&
        Math.abs(center.lng - partner.lng) < 0.002 &&
        Math.abs(center.lat - partner.lat) < 0.002;
      if (alreadyClose) {
        if (showPopup) this.openPopup(partner);
        return;
      }
      this.map.flyTo({
        center: [partner.lng, partner.lat],
        zoom: Math.max(this.map.getZoom(), targetZoom),
        offset: [0, 70],
        speed: 1.35,
        curve: 1.4,
        essential: true
      });
      if (!showPopup) return;
      this.map.once('moveend', function () {
        if (seq !== self.flySeq) return;
        self.openPopup(partner);
      });
    }

    openPopup(partner) {
      const self = this;
      const cityCountry = locationLabel(partner);
      const phoneHref = partner.phone ? 'tel:' + String(partner.phone).replace(/[^\d+]/g, '') : '';
      const html =
        '<div class="partner-locator-popup__inner">' +
          '<p class="partner-locator-popup__name">' + escapeHtml(partner.name) + '</p>' +
          (partner.address ? '<p class="partner-locator-popup__row">' + escapeHtml(partner.address) + '</p>' : '') +
          (cityCountry ? '<p class="partner-locator-popup__row">' + escapeHtml(cityCountry) + '</p>' : '') +
          (partner.phone ? '<p class="partner-locator-popup__row"><a class="partner-locator-popup__phone" href="' + escapeHtml(phoneHref) + '">' + escapeHtml(partner.phone) + '</a></p>' : '') +
          (partner.website ? '<a class="partner-locator-popup__link" href="' + escapeHtml(websiteHref(partner.website)) + '" target="_blank" rel="noopener">' + escapeHtml(this.i18n.website) + '</a>' : '') +
          '<button type="button" class="partner-locator-popup__message" data-popup-message="' + escapeHtml(partner.id) + '">' +
            ICON_MAIL + '<span>' + escapeHtml(this.i18n.message) + '</span>' +
          '</button>' +
        '</div>';
      this.popup.setLngLat([partner.lng, partner.lat]).setHTML(html).addTo(this.map);
      const button = this.popup.getElement().querySelector('[data-popup-message]');
      if (button) {
        button.addEventListener('click', function () {
          self.openModal(partner.id);
        });
      }
    }

    openModal(id) {
      const partner = this.byId[id];
      if (!partner) return;
      this.activePartner = partner;
      this.modalName.textContent = partner.name;
      this.form.reset();
      this.hideFormError();
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const first = this.form.querySelector('input[name="name"]');
      if (first) first.focus();
    }

    closeModal() {
      if (!this.modal || this.modal.hidden) return;
      this.modal.hidden = true;
      document.body.style.overflow = '';
      this.activePartner = null;
      this.setSubmitting(false);
    }

    hideFormError() {
      this.formError.hidden = true;
      this.formError.textContent = '';
    }

    showFormError(message) {
      this.formError.hidden = false;
      this.formError.textContent = message;
    }

    setSubmitting(isSubmitting) {
      this.submitting = isSubmitting;
      this.submitBtn.disabled = isSubmitting;
      this.submitLabel.textContent = isSubmitting ? this.i18n.sending : this.i18n.sendMessage;
    }

    async submitForm() {
      if (this.submitting || !this.activePartner) return;
      const data = new FormData(this.form);
      const name = String(data.get('name') || '').trim();
      const phone = String(data.get('phone') || '').trim();
      const email = String(data.get('email') || '').trim();
      const message = String(data.get('message') || '').trim();
      const privacy = this.form.querySelector('[name="privacy"]').checked;
      this.hideFormError();
      if (!name || !email || !message) {
        this.showFormError(this.i18n.required);
        return;
      }
      if (!validEmail(email)) {
        this.showFormError(this.i18n.invalidEmail);
        return;
      }
      if (!privacy) {
        this.showFormError(this.i18n.privacyRequired);
        return;
      }
      this.setSubmitting(true);
      try {
        const headers = {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        };
        if (this.config.apiKey) headers['X-Api-Key'] = this.config.apiKey;
        const response = await fetch(this.config.endpoint || 'https://ai.baochangqing.com/api/open/partner/message', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            to_email: this.activePartner.email,
            partner_name: this.activePartner.name,
            name: name,
            phone: phone,
            email: email,
            message: message
          })
        });
        let payload = null;
        try { payload = await response.json(); } catch (error) { payload = null; }
        if (!isPartnerMessageSuccess(response, payload)) {
          this.showFormError(partnerMessageError(payload, this.i18n.genericError));
          this.setSubmitting(false);
          return;
        }
        this.closeModal();
      } catch (error) {
        this.showFormError(error && error.message ? error.message : this.i18n.genericError);
        this.setSubmitting(false);
      }
    }

    toggleFullscreen() {
      if (!this.mapWrap) return;
      if (document.fullscreenElement) {
        document.exitFullscreen();
        this.mapWrap.classList.remove('is-fullscreen');
      } else if (this.mapWrap.requestFullscreen) {
        this.mapWrap.requestFullscreen();
        this.mapWrap.classList.add('is-fullscreen');
      } else {
        this.mapWrap.classList.toggle('is-fullscreen');
      }
      const self = this;
      setTimeout(function () { if (self.map) self.map.resize(); }, 200);
    }

    locateMe() {
      if (!navigator.geolocation || !this.map) return;
      const self = this;
      navigator.geolocation.getCurrentPosition(function (position) {
        self.map.flyTo({
          center: [position.coords.longitude, position.coords.latitude],
          zoom: 11,
          essential: true
        });
      });
    }

    resetView() {
      if (!this.map) return;
      if (this.initialBounds && typeof this.initialBounds.getNorth === 'function') {
        this.map.fitBounds(this.initialBounds, { padding: 48, maxZoom: 8 });
      } else {
        this.fitToPartners();
      }
    }
  }

  function featuresId(event) {
    const feature = event.features && event.features[0];
    if (!feature) return '';
    return String((feature.properties && feature.properties.id) || feature.id || '');
  }

  ready(function () {
    document.querySelectorAll('[data-partner-locator]').forEach(function (root) {
      new PartnerLocator(root);
    });
  });
})();
